import { Feature } from '@devxdiscover/devhub-common';

import { EntityPluginAMAChatBot } from '@devxprotect/plugin-devx-chatbot';
import { ConfigFeatureCheck } from '../../custom/util/ConfigFeatureCheck';

/**
 * This component is used to display the bot in all the pages of the DevHub Portal.
 * @returns The main view of the ChatBot component
 */
const ChatBot = () => {
  const isChatBotEnabled = localStorage.getItem('chatbot-flag') !== 'false';

  if (!isChatBotEnabled) {
    return null;
  }

  return (
    <ConfigFeatureCheck feature={Feature.DEVXBOT}>
      <EntityPluginAMAChatBot />
    </ConfigFeatureCheck>
  );
};

export default ChatBot;
